import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const o = s((a, i) => /* @__PURE__ */ l.jsx(
  t,
  {
    ref: i,
    ...a,
    image: (e) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69125)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6.523.79A1 1 0 0 1 7.5 0h1a1 1 0 0 1 .978.79l.567 2.646q.471.211.884.511l2.576-.832a1 1 0 0 1 1.173.452l.5.866a1 1 0 0 1-.196 1.242l-2.007 1.814a5 5 0 0 1 0 1.022l2.007 1.814a1 1 0 0 1 .196 1.242l-.5.866a1 1 0 0 1-1.174.452l-2.575-.832q-.412.298-.884.51l-.567 2.646A1 1 0 0 1 8.5 16h-1a1 1 0 0 1-.977-.79l-.567-2.646a5 5 0 0 1-.885-.512l-2.576.833a1 1 0 0 1-1.173-.452l-.5-.866a1 1 0 0 1 .195-1.242l2.01-1.815a5 5 0 0 1 0-1.02l-2.01-1.815a1 1 0 0 1-.195-1.242l.5-.866a1 1 0 0 1 1.173-.452l2.576.833q.413-.3.885-.512zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69125", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
o.displayName = "SettingsIcon";
export {
  o as SettingsIcon,
  o as default
};
//# sourceMappingURL=index.js.map
